module.exports = __webpack_public_path__ + "assets/images/project/indonesia-detail-1.jpg?v=48117881";